import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { SharedPathSegments } from '@pgaoc/shared-lib';
import { RefreshSessionGuard } from './core/guards/refresh-session.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/layout/layout.routes').then(r => r.routes),
    canActivate: [AuthGuard],
  },
  {
    path: SharedPathSegments.auth(),
    loadChildren: () => import('./features/auth/auth.routes').then(r => r.routes),
    canActivate: [RefreshSessionGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
